import axios from 'axios';
import * as endpoint from '../../../endpoint';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * 企業内のタグ情報を取得する
 *
 * @param {string} apiToken - APIトークン
 * @param {*} apiParams - API パラメータ
 * @param {string} actionType - 成功時にディスパッチするアクションタイプ
 * @returns
 */
const getCompanyAssociatedTags =
  (apiToken, apiParams, actionType) => dispatch => {
    consolelog('[API CALL] getCompanyAssociatedTags()');
    configureAxiosForJSON(apiToken);
    const { cancelToken, cancelTokenKey } = createCancelToken(
      'getCompanyAssociatedTags',
    );
    const url = endpoint.API_GET_COMPANY_TAGS;
    const params = {
      cancelToken,
      params: apiParams,
    };

    return axios
      .get(url, params)
      .then(res => {
        dispatch({
          type: actionType,
          payload: res.data.tags,
          depth: params.params.depth,
          maxDepth: res.data.maxDepth,
        });
      })
      .catch(thrown => {
        if (!axios.isCancel(thrown)) {
          handleErrorResponse(thrown, dispatch);
        }
      })
      .finally(() => delCancelToken(cancelTokenKey));
  };

export default getCompanyAssociatedTags;
